module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/Ham_menu.04090ea8.svg";